/**
 * Created by luka on 23.02.2018.
 */

import {LEVEL_FETCH_DATA_SUCCESS, LEVEL_LOADING, LOADING_LEVEL_FAILED} from "../actions/types";
export function loadingLevelFailed(state = false, action) {
    switch (action.type) {
        case LOADING_LEVEL_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function levelLoading(state = false, action) {
    switch (action.type) {
        case LEVEL_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function levelSet(state = {}, action) {
    switch (action.type) {
        case LEVEL_FETCH_DATA_SUCCESS:
            return action.login;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/level/LevelReducer.js